import { render, staticRenderFns } from "./ProblemResolutionPane.vue?vue&type=template&id=2e78af52&scoped=true"
import script from "./ProblemResolutionPane.vue?vue&type=script&lang=js"
export * from "./ProblemResolutionPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78af52",
  null
  
)

export default component.exports